var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { UserTie } from 'src/core/domain/circles';
import * as moment from 'moment/moment';
import { Map, List } from 'immutable';
// - Import action types
import { CircleActionType } from 'constants/circleActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import * as userActions from 'store/actions/userActions';
import * as notifyActions from 'store/actions/notifyActions';
import * as serverActions from 'store/actions/serverActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
import StringAPI from 'src/api/StringAPI';
import { ServerRequestStatusType } from 'store/actions/serverRequestStatusType';
import { ServerRequestType } from 'constants/serverRequestType';
import { ServerRequestModel } from 'src/models/server/serverRequestModel';
/**
 * Get service providers
 */
var circleService = provider.get(SocialProviderTypes.CircleService);
var userTieService = provider.get(SocialProviderTypes.UserTieService);
/* _____________ CRUD DB _____________ */
/**
 * Add a circle
 * @param {string} circleName
 */
export var dbAddCircle = function (circleName) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var circle = {
            creationDate: moment().unix(),
            name: circleName,
            isSystem: false,
            ownerId: uid
        };
        return circleService.addCircle(uid, circle).then(function (circleKey) {
            circle.id = circleKey;
            circle.ownerId = uid;
            dispatch(addCircle(Map(circle)));
        }, function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/**
 * Add referer user to the `Following` circle of current user
 */
export var dbFollowUser = function (followingCircleId, userFollowing) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var user = __assign({}, state.getIn(['user', 'info', uid]), { userId: uid });
        // Set server request status to {Sent} for following user
        var followReqestModel = createFollowRequest(userFollowing.userId);
        dispatch(serverActions.sendRequest(followReqestModel));
        // Call server API
        return userTieService.tieUseres({ userId: user.userId, fullName: user.fullName, avatar: user.avatar, approved: false }, { userId: userFollowing.userId, fullName: userFollowing.fullName, avatar: userFollowing.avatar, approved: false }, [followingCircleId])
            .then(function () {
            var userTie = Map(new UserTie(userFollowing.userId, moment().unix(), userFollowing.fullName, userFollowing.avatar, false));
            userTie = userTie.set('circleIdList', List([followingCircleId]));
            dispatch(addFollowingUser(userTie));
            // Set server request status to {OK} for following user
            followReqestModel.status = ServerRequestStatusType.OK;
            dispatch(serverActions.sendRequest(followReqestModel));
            // Send notification
            dispatch(notifyActions.dbAddNotification({
                description: user.fullName + " started following you.",
                url: "/" + uid,
                notifyRecieverUserId: userFollowing.userId,
                notifierUserId: uid,
                isSeen: false
            }));
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            // Set server request status to {Error} for following user
            followReqestModel.status = ServerRequestStatusType.Error;
            dispatch(serverActions.sendRequest(followReqestModel));
        });
    };
};
/**
 * Update user in circle/circles
 */
export var dbUpdateUserInCircles = function (circleIdList, userFollowing) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var user = __assign({}, state.getIn(['user', 'info', uid]), { userId: uid });
        // Set server request status to {Sent}
        var addToCircleRequest = createAddToCircleRequest(userFollowing.userId);
        dispatch(serverActions.sendRequest(addToCircleRequest));
        dispatch(globalActions.showMasterLoading());
        // Call server API
        return userTieService.updateUsersTie({ userId: user.userId, fullName: user.fullName, avatar: user.avatar, approved: false }, { userId: userFollowing.userId, fullName: userFollowing.fullName, avatar: userFollowing.avatar, approved: false }, circleIdList.toJS())
            .then(function () {
            var userTie = Map(new UserTie(userFollowing.userId, moment().unix(), userFollowing.fullName, userFollowing.avatar, false));
            userTie = userTie.set('circleIdList', circleIdList);
            dispatch(addFollowingUser(userTie));
            // Set server request status to {OK}
            addToCircleRequest.status = ServerRequestStatusType.OK;
            dispatch(serverActions.sendRequest(addToCircleRequest));
            dispatch(globalActions.hideMasterLoading());
            // Close select circle box
            dispatch(closeSelectCircleBox(userFollowing.userId));
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideMasterLoading());
            // Set server request status to {Error}
            addToCircleRequest.status = ServerRequestStatusType.Error;
            dispatch(serverActions.sendRequest(addToCircleRequest));
        });
    };
};
/**
 * Delete following user
 */
export var dbDeleteFollowingUser = function (userFollowingId) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        // Set server request status to {Sent}
        var deleteFollowingUserRequest = createdeleteFollowingUserRequest(userFollowingId);
        dispatch(serverActions.sendRequest(deleteFollowingUserRequest));
        dispatch(globalActions.showMasterLoading());
        // Call server API
        return userTieService.removeUsersTie(uid, userFollowingId)
            .then(function () {
            dispatch(deleteFollowingUser(userFollowingId));
            dispatch(globalActions.hideMasterLoading());
            // Close select circle box
            dispatch(closeSelectCircleBox(userFollowingId));
            // Set server request status to {OK}
            deleteFollowingUserRequest.status = ServerRequestStatusType.OK;
            dispatch(serverActions.sendRequest(deleteFollowingUserRequest));
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideMasterLoading());
            // Close select circle box
            dispatch(closeSelectCircleBox(userFollowingId));
            // Set server request status to {Error}
            deleteFollowingUserRequest.status = ServerRequestStatusType.Error;
            dispatch(serverActions.sendRequest(deleteFollowingUserRequest));
        });
    };
};
/**
 * Update a circle from database
 */
export var dbUpdateCircle = function (newCircle) {
    return function (dispatch, getState) {
        // Get current user id
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        // Write the new data simultaneously in the list
        var circle = state.getIn(['circle', 'circleList', newCircle.id]);
        circle = circle.set('name', newCircle.name);
        return circleService.updateCircle(uid, newCircle.id, circle.toJS())
            .then(function () {
            circle = circle.set('id', newCircle.id);
            dispatch(updateCircle(circle));
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/**
 * Delete a circle from database
 */
export var dbDeleteCircle = function (circleId) {
    return function (dispatch, getState) {
        // Get current user id
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        return circleService.deleteCircle(uid, circleId)
            .then(function () {
            dispatch(deleteCircle(circleId));
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/**
 *  Get all circles from data base belong to current user
 */
export var dbGetCircles = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return circleService.getCircles(uid)
                .then(function (circles) {
                dispatch(addCircles(circles));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 *  Get all user ties from data base
 */
export var dbGetUserTies = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            userTieService.getUserTies(uid).then(function (result) {
                dispatch(userActions.addPeopleInfo(result));
                dispatch(addUserTies(result));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 *  Get all followers
 */
export var dbGetFollowers = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            userTieService.getUserTieSender(uid).then(function (result) {
                dispatch(userActions.addPeopleInfo(result));
                dispatch(addUserTieds(result));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 * Get all user circles from data base by user id
 * @param uid user identifier
 */
export var dbGetCirclesByUserId = function (uid) {
    return function (dispatch, getState) {
        if (uid) {
            return circleService.getCircles(uid)
                .then(function (circles) {
                dispatch(addCircles(circles));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 * Create follow user serevr request model
 */
var createFollowRequest = function (userFollowingId) {
    var requestId = StringAPI.createServerRequestId(ServerRequestType.CircleFollowUser, userFollowingId);
    return new ServerRequestModel(ServerRequestType.CircleFollowUser, requestId, '', ServerRequestStatusType.Sent);
};
/**
 * Create add referer user to circle serevr request model
 */
var createAddToCircleRequest = function (userFollowingId) {
    var requestId = StringAPI.createServerRequestId(ServerRequestType.CircleAddToCircle, userFollowingId);
    return new ServerRequestModel(ServerRequestType.CircleAddToCircle, requestId, '', ServerRequestStatusType.Sent);
};
/**
 * Create delete referer user serevr request model
 */
var createdeleteFollowingUserRequest = function (userFollowingId) {
    var requestId = StringAPI.createServerRequestId(ServerRequestType.CircleDeleteFollowingUser, userFollowingId);
    return new ServerRequestModel(ServerRequestType.CircleDeleteFollowingUser, requestId, '', ServerRequestStatusType.Sent);
};
/* _____________ CRUD State _____________ */
/**
 * Add a circle
 */
export var addCircle = function (circle) {
    return {
        type: CircleActionType.ADD_CIRCLE,
        payload: { circle: circle }
    };
};
/**
 * Update a circle
 */
export var updateCircle = function (circle) {
    return {
        type: CircleActionType.UPDATE_CIRCLE,
        payload: { circle: circle }
    };
};
/**
 * Delete a circle
 */
export var deleteCircle = function (circleId) {
    return {
        type: CircleActionType.DELETE_CIRCLE,
        payload: { circleId: circleId }
    };
};
/**
 * Add a list of circle
 */
export var addCircles = function (circleList) {
    return {
        type: CircleActionType.ADD_LIST_CIRCLE,
        payload: { circleList: circleList }
    };
};
/**
 * Clea all data in circle store
 */
export var clearAllCircles = function () {
    return {
        type: CircleActionType.CLEAR_ALL_CIRCLES
    };
};
/**
 * Open circle settings
 */
export var openCircleSettings = function (circleId) {
    return {
        type: CircleActionType.OPEN_CIRCLE_SETTINGS,
        payload: { circleId: circleId }
    };
};
/**
 * Close open circle settings
 */
export var closeCircleSettings = function (circleId) {
    return {
        type: CircleActionType.CLOSE_CIRCLE_SETTINGS,
        payload: { circleId: circleId }
    };
};
/**
 * Add following user
 */
export var addFollowingUser = function (userTie) {
    return {
        type: CircleActionType.ADD_FOLLOWING_USER,
        payload: { userTie: userTie }
    };
};
/**
 * Update the user tie
 */
export var updateUserTie = function (userTie) {
    return {
        type: CircleActionType.UPDATE_USER_TIE,
        payload: { userTie: userTie }
    };
};
/**
 * Add user ties
 */
export var addUserTies = function (userTies) {
    return {
        type: CircleActionType.ADD_USER_TIE_LIST,
        payload: { userTies: userTies }
    };
};
/**
 * Add users who send tie request for current user
 */
export var addUserTieds = function (userTieds) {
    return {
        type: CircleActionType.ADD_USER_TIED_LIST,
        payload: { userTieds: userTieds }
    };
};
/**
 * Delete the user from a circle
 */
export var deleteUserFromCircle = function (userId, circleId) {
    return {
        type: CircleActionType.DELETE_USER_FROM_CIRCLE,
        payload: { userId: userId, circleId: circleId }
    };
};
/**
 * Delete following user
 */
export var deleteFollowingUser = function (userId) {
    return {
        type: CircleActionType.DELETE_FOLLOWING_USER,
        payload: { userId: userId }
    };
};
/**
 * Show the box to select circle
 */
export var showSelectCircleBox = function (userId) {
    return {
        type: CircleActionType.SHOW_SELECT_CIRCLE_BOX,
        payload: { userId: userId }
    };
};
/**
 * Hide the box to select circle
 */
export var hideSelectCircleBox = function (userId) {
    return {
        type: CircleActionType.HIDE_SELECT_CIRCLE_BOX,
        payload: { userId: userId }
    };
};
/**
 * Show loading on following user
 */
export var showFollowingUserLoading = function (userId) {
    return {
        type: CircleActionType.SHOW_FOLLOWING_USER_LOADING,
        payload: { userId: userId }
    };
};
/**
 * Set current user selected circles for referer user
 */
export var setSelectedCircles = function (userId, circleList) {
    return {
        type: CircleActionType.SET_SELECTED_CIRCLES_USER_BOX_COMPONENT,
        payload: { userId: userId, circleList: circleList }
    };
};
/**
 * Remove current user selected circles for referer user
 */
export var removeSelectedCircles = function (userId) {
    return {
        type: CircleActionType.REMOVE_SELECTED_CIRCLES_USER_BOX_COMPONENT,
        payload: { userId: userId }
    };
};
/**
 * Open select circle box
 */
export var openSelectCircleBox = function (userId) {
    return {
        type: CircleActionType.OPEN_SELECT_CIRCLES_USER_BOX_COMPONENT,
        payload: { userId: userId }
    };
};
/**
 * Close select circle box
 */
export var closeSelectCircleBox = function (userId) {
    return {
        type: CircleActionType.CLOSE_SELECT_CIRCLES_USER_BOX_COMPONENT,
        payload: { userId: userId }
    };
};
/**
 * Hide loading on following user
 */
export var hideFollowingUserLoading = function (userId) {
    return {
        type: CircleActionType.HIDE_FOLLOWING_USER_LOADING,
        payload: { userId: userId }
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/circleActions.ts
// module id = 397
// module chunks = 50